import { Operation, opName } from "./Operation";

export enum ToolKind {
    Op = "op",
    Multistep = "steps"
}

/// A tool that's a single operation.
export interface OpTool {
    readonly kind: ToolKind.Op;
    op: Operation;
    packedParams?: Record<string, any>;
    /// The time the user last modified the packed params.
    modTimestamp?: string;
}

// Note: this interface stayed stable across the migration from the old schema
// to the new schema, which means the import and export code didn't need to
// change.
/// A list of multiple operations.
export interface MultistepTool {
    kind: ToolKind.Multistep;
    /// Has this multistep tool been synced to the server?
    pushed?: boolean;
    /// The time the user last modified the packed steps.
    modTimestamp?: string;
    name: string;
    thumbnailUrl: string;
    thumbnailWidth: number;
    thumbnailHeight: number;
    // A list of packed Params.
    packedSteps: Record<string, any>[];
}

export type Tool = OpTool | MultistepTool;

export function isOp(tool: Tool): tool is OpTool {
    return tool.kind == ToolKind.Op;
}

export function isMultistep(tool: Tool): tool is MultistepTool {
    return tool.kind == ToolKind.Multistep;
}

/// A toolbox cannot contain two tools with the same key.  The key is basically
/// the name of the tool.
export function keyForTool(tool: Tool): string {
    if (tool.kind == ToolKind.Op) {
        return `Op-${tool.op}`;
    } else {
        return `Multi-${tool.name}`;
    }
}

export function toolName(t: (key: string) => string, tool: Tool): string {
    switch (tool.kind) {
        case ToolKind.Op: return opName(t, tool.op);
        case ToolKind.Multistep: return tool.name;
    }
}
